import {
  WIFI_OFF_STEP_NAME,
  WIFI_ON_STEP_NAME,
  WIFI_VERIFY_TIMEOUT_MS,
} from '@mxa-argos/modules/forja/constants/forja.constants';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import type { ForjaDeviceSession } from '@mxa-argos/modules/forja/lib/engine/forja-device-session';

const WIFI_DISABLED_OUTPUT = 'Wifi is disabled';

// Every remote order of the run reaches the device through Proget, and a previous run left the
// wifi off with no SIM to fall back on.
export function wifiOnStep(): ForjaStep {
  return {
    name: WIFI_ON_STEP_NAME,
    verify: (device) => isWifiDisabled(device).then((isDisabled) => !isDisabled),
    apply: async (device) => {
      await device.shell('cmd', 'wifi', 'set-wifi-enabled', 'enabled');
    },
    verifyTimeoutMs: WIFI_VERIFY_TIMEOUT_MS,
  };
}

export function wifiOffStep(): ForjaStep {
  return {
    name: WIFI_OFF_STEP_NAME,
    verify: isWifiDisabled,
    apply: async (device) => {
      await device.shell('cmd', 'wifi', 'set-wifi-enabled', 'disabled');
    },
    verifyTimeoutMs: WIFI_VERIFY_TIMEOUT_MS,
  };
}

function isWifiDisabled(device: ForjaDeviceSession): Promise<boolean> {
  return device
    .shell('cmd', 'wifi', 'status')
    .then((status) => status.includes(WIFI_DISABLED_OUTPUT));
}
